export default {
  activeDays: '激活日期',
  ageDictionaries: '年龄字典',
  ageGroups: '年龄组',
  amount: '总数',
  atteAndJounral: '出勤和事件',
  attendance: '出勤',
  absent: '缺勤',
  basic: '基本',
  bookingDays: '预定日期',
  bookingType: '预定类型',
  capacity: 'Capacity',
  catalog: '清单',
  center: '中心',
  centers: '中心',
  certifications: '证书',
  changeDate: '改变日期',
  changeRate: '改变报价',
  city: '城市',
  classes: '班级',
  closeDate: '关闭日期',
  color: '颜色',
  conductionDate: '执行日期',
  contactInfo: '联系方式',
  communicate: '沟通',
  country: '国家',
  criminalRecord: '犯罪记录',
  cycle: '周期',
  dateOfBirth: '出生日期',
  desc: '描述',
  description: '描述',
  discounts: '折扣',
  displayOptions: '显示选项',
  education: '教育',
  emailAddress: '邮箱地址',
  exportPortableRecord: '导出便携记录',
  exportPortableRecordDescription:
    '下载该员工的便携记录 PDF，不包含薪资信息和 SIN 号码。',
  event: '事件',
  families: '家庭',
  family: '家庭',
  finances: '财务',
  firstAid: '急救',
  firstName: '名',
  gender: '性别',
  graduateRate: '毕业报价',
  group: '群组',
  groupByStaff: '按员工分组',
  groupCapacity: '群组容量',
  groupEndDate: '群组结束日期',
  groupStartDate: '群组开始日期',
  groups: '群组',
  health: '健康',
  healthCareNumber: '健康号码',
  holidays: '假日',
  info: '信息',
  interactions: '交互',
  interventionCheck: '干涉记录',
  isSchoolRequired: '学校是否必填',
  jobInfo: '职位信息',
  journal: '日记',
  journalVideoInvalid: '无法读取此视频，请尝试其他文件。',
  journalVideoTooLong: '视频时长不得超过 90 秒。',
  journalVideoTooLarge: '视频大小不得超过 200MB。',
  lastName: '姓',
  ledger: '账本',
  locations: '位置',
  locationMessagesGroup: {
    inUseError: '无法删除正在使用的位置',
  },
  login: '登录',
  logout: '登出',
  liveWith: '一起居住',
  main: '主要',
  marketing: '市场',
  meal: '饮食',
  medication: '药物',
  medicalAndEmergencyDetails: '医疗和紧急情况详细信息',
  message: '信息',
  messagesGroup: {
    fail: '哦，出错了',
    internalError: '哦！服务端发生错误',
    success: '成功',
    unknownError: '哦! 发生未知错误',
  },
  middleName: '中间名',
  name: '名字',
  nextFormalReview: '未来正式审查',
  openDate: '开始日期',
  new: '新增',
  optional: '(可选)',
  organization: '机构',
  other: '其他',
  outstand: '未付',
  paymentDue: '付款截止',
  per: '通过',
  permittedUses: '允许用途',
  physical: '体质',
  pods: 'Pods',
  pod: 'Pod',
  podMessagesGroup: {
    inUseError: '无法删除正在使用的运输组',
  },
  postalCode: '邮编',
  preferredName: '偏好名',
  preRegistrations: '预注册',
  process: '运行',
  processing: '执行',
  present: '出勤',
  program: '计划',
  programs: '计划',
  province: '省',
  rates: '报价',
  records: '记录',
  registration: '注册',
  registrations: '注册',
  registrationDeposit: '注册押金',
  required: '必填',
  reviewDate: '审查日期',
  role: '角色',
  schedules: '计划',
  schoolMessagesGroup: {
    inUseError: '无法删除正在使用的学校',
  },
  settlement: '结算',
  setup: '设置',
  shortName: '短名',
  socialEmotional: '社交 & 心里',
  socialInsuranceNumber: '社会保险号',
  spaces: '空间',
  specialNeeds: '特殊需求',
  sponsors: '资助人',
  sponsorSelection: '资助人选择',
  staff: '员工',
  staffRoles: '员工角色',
  state: '州',
  status: '状态',
  address: '地址',
  student: '学生',
  style: '样式',
  tasks: '任务',
  teamRatioRules: '团队比例规则',
  theme: '主题',
  totals: '总计',
  type: '类型',
  transport: '交通',
  username: '用户名',
  waitListDeposit: '等待队列押金',
  schools: '学校',
  agreementsSignedReport: '已签署协议报表',
  agreementsToTrack: '要跟踪的协议',
  hideChildrenWithAllSelectedAgreementsSigned: '隐藏已签署所有所选协议的儿童',
  signed: '已签署',
}
